const buildGetItemLayout =
  <T>(length: number, divider: number = 0) =>
  (_: T, index: number) => ({
    index,
    length,
    offset: (length + divider) * index,
  })

export default buildGetItemLayout
